import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import DatePicker, {Calendar, DayValue} from "@hassanmojab/react-modern-calendar-datepicker";
import {DateFixToGoLayout, GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {NumberToPersianLetters} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsStaffEditContractModal = (props: {
    active: boolean,
    closeHandler: any,
    baseSalary: number,
    mustHoursPerWeek: number,
    maxHoursPerDay: number,
    startAt: string,
    expiresAt: string,
    bankAccount: string,
    onDone: any,
    staffId: string,
}) => {
    const [salary, setSalary] = useState('');
    const [mustHoursPerWeek, setMustHoursPerWeek] = useState('');
    const [maxHoursPerDay, setMaxHoursPerDay] = useState('');
    const [startAt, setStartAt] = useState<DayValue>(null);
    const [expiresAt, setExpiresAt] = useState<DayValue>(null);
    const [bankAccount, setBankAccount] = useState('');
    const ids = {
        salary: useId(),
        mustPerWeek: useId(),
        maxPerDay: useId(),
        bank: useId(),
    };
    const [err, setErr] = useState({
        salary: false,
        mustHoursPerWeek: false,
        maxHoursPerDay: false,
        bankAccount: false,
    });
    useEffect(() => {
        const isActive = props.active;
        const _salary = props.baseSalary;
        const _mustHoursPerWeek = props.mustHoursPerWeek;
        const _maxHoursPerDay = props.maxHoursPerDay;
        const _startAt = props.startAt;
        const _expiresAt = props.expiresAt;
        const _bank = props.bankAccount;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setSalary(_salary.toString());
            setMustHoursPerWeek(_mustHoursPerWeek.toString());
            setMaxHoursPerDay(_maxHoursPerDay.toString());
            setBankAccount(_bank);
            const bd = GregorianToPersian(_startAt).split('-');
            setStartAt({
                year: parseInt(bd[0]),
                month: parseInt(bd[1]),
                day: parseInt(bd[2]),
            });
            const bd1 = GregorianToPersian(_expiresAt).split('-');
            setExpiresAt({
                year: parseInt(bd1[0]),
                month: parseInt(bd1[1]),
                day: parseInt(bd1[2]),
            });
            setErr({
                bankAccount: false,
                maxHoursPerDay: false,
                mustHoursPerWeek: false,
                salary: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const data = {
            id:props.staffId.toString(),
            salary:salary,
            mustPerWeek:mustHoursPerWeek,
            maxPerDay:maxHoursPerDay,
            bankAccount:bankAccount,
            startAt:PersianToGregorian(DateFixToGoLayout(`${startAt?.year}-${startAt?.month}-${startAt?.day}`)),
            expiresAt:PersianToGregorian(DateFixToGoLayout(`${expiresAt?.year}-${expiresAt?.month}-${expiresAt?.day}`)),
        };
        let errors = {
            salary: false,
            mustHoursPerWeek: false,
            maxHoursPerDay: false,
            bankAccount: false,
        };
        let stop = false;
        if(data.salary === ''){
            stop = true;
            errors.salary = true;
        }
        if(data.mustPerWeek === ''){
            stop = true;
            errors.mustHoursPerWeek = true;
        }
        if(data.maxPerDay === ''){
            stop = true;
            errors.maxHoursPerDay = true;
        }
        if(data.bankAccount === ''){
            stop = true;
            errors.bankAccount = true;
        }
        setErr(errors);
        if(stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/details/contract/edit',
            data,
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.closeHandler();
                props.onDone();
                ShowSnackbar(
                    'قرارداد ویرایش شد.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-full-screen" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>تنظیم قرارداد کارمند</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4">
                                    <label htmlFor={ids.salary}>پایه حقوق:</label>
                                    <input type="number"
                                           min={0}
                                           id={ids.salary}
                                           className={"form-control" + (err.salary ? ' is-invalid' : '')}
                                           value={salary}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setSalary(t);
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.salary = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    {
                                        salary !== '' ?
                                            <span style={{
                                                display: 'block',
                                                margin: '5px 0 0 0',
                                                fontWeight: 400,
                                                color: '#0a53be'
                                            }}>{NumberToPersianLetters(parseInt(salary)) + " تومان"}</span> : null
                                    }
                                    <div className={"invalid-feedback" + (err.salary ? ' d-block' : ' d-none')}>
                                        لطفا این سطر را تکمیل کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label htmlFor={ids.mustPerWeek}>تعداد ساعات الزامی در هفته:</label>
                                    <input type="number"
                                           min={0}
                                           id={ids.mustPerWeek}
                                           className={"form-control" + (err.mustHoursPerWeek ? ' is-invalid' : '')}
                                           value={mustHoursPerWeek}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setMustHoursPerWeek(t);
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.mustHoursPerWeek = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback" + (err.mustHoursPerWeek ? ' d-block' : ' d-none')}>
                                        لطفا این سطر را تکمیل کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label htmlFor={ids.maxPerDay}>حداکثر ساعات کاری روزانه:</label>
                                    <input type="number"
                                           min={0}
                                           id={ids.maxPerDay}
                                           className={"form-control" + (err.maxHoursPerDay ? ' is-invalid' : '')}
                                           value={maxHoursPerDay}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setMaxHoursPerDay(t);
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.maxHoursPerDay = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback" + (err.maxHoursPerDay ? ' d-block' : ' d-none')}>
                                        لطفا این سطر را تکمیل کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <label htmlFor={ids.bank}>شماره حساب بانکی:</label>
                                    <input type="text"
                                           id={ids.bank}
                                           className={"form-control" + (err.bankAccount ? ' is-invalid' : '')}
                                           value={bankAccount}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setBankAccount(t);
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.bankAccount = false;
                                                   return x;
                                               });
                                           }}
                                    />
                                    <div
                                        className={"invalid-feedback" + (err.bankAccount ? ' d-block' : ' d-none')}>
                                        شماره حساب وارد شده صحیح نمی‌باشد.
                                    </div>
                                    <div style={{height: 20}}/>
                                </div>
                                <div className="col-lg-4">
                                    <label>تاریخ شروع قرارداد:</label>
                                    <Calendar
                                        value={startAt}
                                        onChange={e => setStartAt(e)}
                                        shouldHighlightWeekends
                                        colorPrimary='#0a53be'
                                        locale='fa'
                                    />
                                    <div style={{height: 20}}/>
                                </div>
                                <div className="col-lg-4">
                                    <label>تاریخ پایان قرارداد:</label>
                                    <Calendar
                                        value={expiresAt}
                                        onChange={e => setExpiresAt(e)}
                                        shouldHighlightWeekends
                                        colorPrimary='#0a53be'
                                        locale='fa'
                                    />
                                    <div style={{height: 20}}/>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-center"
                                 style={{marginTop: 40, gap: 5}}>
                                <button className="cancel-button" onClick={props.closeHandler}>
                                    <b>انصراف</b>
                                </button>
                                <button className="btn-pay" onClick={saveChanges}>
                                    <b>ذخیره تغییرات</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};